define('ch_simple_filters',[
    'jquery',
    'noUiSlider',
    'dayjs',
    'dayjsCustomParseFormat',
    'services',
    'semantic',
    'semantic-calendar',
    'ch_scrollto',
    'ch_intl',
], function ($, noUiSlider, dayjs, dayjsCustomParseFormat) {
    /**
     * user defined options
     */
    var options = {
        resultsCb: () => {},
        popStateCb: () => {},
    };

    dayjs.extend(dayjsCustomParseFormat);

    /**
     * the filter form
     */
    var $form;

    /**
     * The filter element
     */
    var $filterSimpleContainer;

    /**
     * debounce timer
     */
    var simpleFilterSubmitTimer;

    /**
     * target element where search results are loaded into via ajax
     */
    var $resultsContainer;

    /**
     * column (or wrapping container) for search results used for dimming
     */
    var $resultsColumn;

    /**
     * container element for all results and the subheader
     */
    var $browseContainer;

    var $filterPageContainer;

    var $formResetButtons;

    /**
     * Element containing all filter drawers
     */
    var $filterDrawer;

    /**
     * Reference to the "sticky" filter bar
     * undefined when the bar is not set as sticky
     */
    var $stickyFilters;

    /**
     * Reference to the "sticky" map
     */
    var $stickyMap;

    /**
     * Element containing a message about there being no results
     */
    var $noResultsMessage;

    var $neighborhoodFilters;

    var $hoods;

    /**
     * entire page element (ios prefers noscroll on html)
     *
     * @type {*|jQuery|HTMLElement}
     */
    var $body;

    /**
     * Category filter drawer element
     */
    var $categoryFilterDrawer;

    var $daysAndTimesFilters;

    var $moreFiltersDrawer;

    /**
     * the serialized form cache
     */
    var formSerialized;

    function checkSimpleFilterSubmit($form, eventOptions) {
        $form.data('is-dirty', true);

        if (simpleFilterSubmitTimer) {
            clearTimeout(simpleFilterSubmitTimer);
        }

        simpleFilterSubmitTimer = setTimeout(function () {
            $form.trigger('submit', eventOptions);
        }, 1000);
    }

    /**
     * Toggle filter page dimmer(s)
     * @param behavior string       "show" or "hide"
     */
    function toggleDimmers(behavior) {
        if (CH && CH.isMobile) {
            $filterPageContainer.dimmer(behavior);
        } else {
            $resultsColumn.dimmer(behavior);
        }
    }

    /**
     * serializeForm
     *
     * Digests the simple filters form and returns a serialized representation of it
     * Used for submission and tracking state change
     *
     * @param jQuerySelector $form - the simple filters form
     * @return string
     */
    function serializeForm($form) {
        // Look for checked parent hoods where the number of unchecked child hoods is zero.
        // Disable those child hoods so they don't submit with the form
        $neighborhoodFilters.find('.js-borough-field input[type=checkbox]:checked').each(function () {
            var targetHoodSelector = '.' + $(this).data('target');
            var $hoodFields = $hoods.filter(targetHoodSelector)
                .find('input[type=checkbox]');

            if ($hoodFields.filter(':checked').length == $hoodFields.length) {
                $hoodFields.prop('disabled', true);
            }
        });

        convertCbGroupsToStrings([
            '.js-days-of-the-week-filter input[type="checkbox"]:not(:disabled)',
            '.js-skill-level-filter input[type="checkbox"]:not(:disabled)',
            '.js-age-filter input[type="checkbox"]:not(:disabled)',
            '#js-neighborhoods-filters input[type="checkbox"]:not(:disabled)',
            '.js-frequency-filter input[type="checkbox"]:not(:disabled)',
        ], $form);

        // get form data object before we deactivate everything
        formData = $form.serializeArray();

        // submit only:
        // - inputs with values (includes radios)
        // - select lists
        return $(':input[value!=""][data-serialize!="false"]', $form)
            .not('input[type="checkbox"]')
            .serialize();
    }

    /**
     * submitSimpleFilters
     *
     * @param $form                     the form
     * @param $resultsColumn            the results container (to refresh)
     * @param recordHistory boolean     true to record the filter submission in browser history stack
     */
    function submitSimpleFilters($form, $resultsColumn, recordHistory) {
        var formData;
        var recordHistory = recordHistory || false;
        var parsedUrl = parseUri(window.location.href);
        var baseUrl;
        var $loader = $('.js-filter-loading', $form);

        toggleDimmers('show');

        $loader.removeClass('hidden');
        $formResetButtons.addClass('hidden');

        formSerialized = serializeForm($form);

        // set baseUrl based on any selected categories, otherwise current url
        baseUrl = parsedUrl.protocol
            + '://'
            + parsedUrl.host
            + parsedUrl.path;

        // store form data as object
        if (recordHistory) {
            history.pushState(
                formData,
                'Filtering',
                baseUrl + (formSerialized ? '?' + formSerialized : '')
            );
        }

        $.ajax({
            method: 'GET',
            url: baseUrl,
            dataType: 'html',
            data: formSerialized,
        }).done(function (data, status, jq) {
            var $paginationControls;
            var totalResults;
            var sellableResults;

            // go to the top of the page
            CH.scrollTo(0);

            // update results first...
            $resultsContainer.html(data);

            // run user-specified callback
            options.resultsCb.call(this);

            // then fetch latest counts
            $paginationControls = $resultsColumn.find('.pagination');
            totalResults = $paginationControls.data('total-results') || 0;

            $noResultsMessage.toggleClass('active', totalResults <= 0);

            sellableResults = $paginationControls.data('sellable-results') || 0;

            // and update counts
            $('.js-result-count').html(
                totalResults + ' ' + (totalResults === 0 || totalResults > 1 ? 'classes' : 'class')
            );
            $('.js-filter-results-sellable-count').html(sellableResults);

            CH.initSemanticWishlist();
            if (CH && CH.isMobile) {
                // After submitting the form on mobile, we trigger the click handler on the active
                // filter toggle button to trigger the filter drawer collapse behavior
                // and all of its sideeffects
                $('.ui.button.active.js-filter-toggle', $form).trigger('click');
            }
        }).fail(function (jq, status, error) {
            swal({
                title: 'Something went wrong', // @todo - placeholder copy
                type: 'error',
                confirmButtonText: 'Retry',
                closeOnConfirm: true,
            }, function () {
                $form.submit();
            });
        }).always(function () {
            toggleDimmers('hide');

            $loader.addClass('hidden');
            $formResetButtons.removeClass('hidden');
            // Don't leave the child hoods disabled so the user can edit
            $hoods
                .find('input[type=checkbox]:disabled')
                .prop('disabled', false);
            // form is no longer dirty
            $form.data('is-dirty', false);
        });
    }

    function emitGAFilterEvent(filterName) {
        if (filterName) {
            // ditch any [] chars
            filterName = filterName.replace(/\[\]/g, '');
            // first char uppercase for pretty times
            filterName = filterName.charAt(0).toUpperCase() + filterName.slice(1);

            ga(
                'send',
                'event',
                'Filter Simple', // category
                'Field Changed',
                filterName,
                { nonInteraction: false }
            );
        }
    }

    function trackMobileSimpleFilterFieldChange(serializedForm) {
        serializedForm.split('&').forEach(function (filter) {
            emitGAFilterEvent(filter.split('=')[0]);
        });
    }


    function trackSimpleFilterFieldChange() {
        emitGAFilterEvent($(this).attr('name'));
    }

    var minPriceVal = 0;
    var maxPriceVal = 3000;

    function initMobileBehavior($form) {
        require(['ch_accordion'], function (accordions) {
            accordions.init();
        });

        // make price "options" (the radio buttons) set the hidden price field
        var $priceOptionFields = $('input[name="price-options"]', $form);
        var $priceField = $('input[name=price]', $form);

        $priceOptionFields.on('change', function () {
            $priceField.val($(this).val()).trigger('change');
        });

        // set up the mobile-only sort field
        initSortMenu($form);

        toggleApplyFiltersButton();
    }

    function initDimmers($filterPageContainer, $resultsColumn) {
        if (CH && CH.isMobile) {
            $filterPageContainer.dimmer({
                className: {
                    active: 'active desktop-hide',
                },
                template: {
                    dimmer: function () {
                        return $('#browse-searching-dimmer');
                    },
                },
            });
        } else {
            $resultsColumn.dimmer({
                variation: 'inverted',
                className: {
                    active: 'active mobile-hide',
                },
            });
        }
    }

    /**
     * initializeSimpleFilter
     *
     * Note: do not use semanticUi .checkbox() on these form fields, it's slow... and we have A LOT of checkboxes
     *
     * @param resultsCb     callback to trigger after filter results are loaded
     */
    function initializeSimpleFilter(userOptions) {
        $filterSimpleContainer = $('#filter-simple-container');

        options = Object.assign(options, userOptions);

        // set shared $element vars
        $form = $('#filter-simple-form');
        $resultsColumn = $('.js-filter-results-column.ui.column', '#filter-results');
        $resultsContainer = $resultsColumn.find('.js-filter-results-container');
        $browseContainer = $('.browse-results-container');
        $filterPageContainer = $('#filter-page-container');
        $formResetButtons = $('.js-form-reset');
        $filterDrawer = $('.js-filters-drawer');
        $noResultsMessage = $('.js-no-results');
        $neighborhoodFilters = $('#js-neighborhoods-filters');
        $hoods = $neighborhoodFilters.find('.child-hoods');
        $daysAndTimesFilters = $('#js-days-and-times-filters');
        $moreFiltersDrawer = $('#js-more-filters');
        $body = $('body');

        // set up dimmers
        initDimmers($filterPageContainer, $resultsColumn);

        var $timeField = $('input[name=time]', $form);
        var $dateField = $('input[name=date]', $form);
        var $priceField = $('input[name=price]', $form);
        var $priceMinText = $('#js-price-filters .price.start', $form);
        var $priceMaxText = $('#js-price-filters .price.end', $form);
        var priceSlider = document.getElementById('js-slider');
        var $seatsDropdown = $('.js-seats-filter .dropdown', $form);
        var $seatsField = $('input[name=available_seats]', $form);
        var $applyFilters = $('.js-apply-filters-button', $form);
        var $grouperModal = $('.ui.modal.grouper-attendee-modal', $filterSimpleContainer);

        $applyFilters.hide();

        /**
         * submit the form
         *
         * @param e         event
         * @param options   {recordHistory: boolean}
         */
        function submitForm(e, eventOptions) {
            var newFormData = serializeForm($form);
            if (CH && CH.isMobile) {
                toggleAllActiveDrawerButtons($filterDrawer, $form);
                trackMobileSimpleFilterFieldChange(newFormData);
            } else {
                toggleActiveDrawerButtonsFromEvent(e);
                trackSimpleFilterFieldChange.call(this);
            }
            checkSimpleFilterSubmit($form, eventOptions);
            // Refresh the serialized form filter cache
            formSerialized = newFormData;
            toggleApplyFiltersButton();
        }

        // when changing fields, submit the form
        if (CH && CH.isMobile) {
            // The apply filters button is only present on mobile
            // so we only register this click handler when we're
            // in the mobile version of the site
            $applyFilters.on('click', function (e) {
                submitForm(e);
            });

            $('select, input', $form).on('change', function (evt) {
                toggleApplyFiltersButton();
            });
        } else {
            $('select, input', $form).on('change', submitForm);
        }


        // initialize form submission
        $form.on('submit', function (e, options) {
            options = Object.assign({
                recordHistory: true,
            }, options);

            submitSimpleFilters(
                $form,
                $resultsColumn,
                options.recordHistory
            );

            return false;
        });

        // reset all form fields to empty or defaults
        function resetForm(e, options) {
            options = Object.assign({
                submitForm: true,
            }, options);

            // by default form.reset does not clear hidden fields
            // reset specific hidden fields
            $timeField.val('');
            $dateField.val('');
            $priceField.val('');

            setTimeFields($timeField.val(), false);
            setDateFields($dateField.val(), false);
            priceSlider.noUiSlider.reset(false);

            // Ensure that the available_seats form field is reset to nothing
            // It is then displayed as 1 Person, which is the default, but it's not
            // to be included in the query params
            $seatsDropdown.dropdown('set selected', '1');
            // This seems like it shouldn't be necessary, but to be sure we're setting the hidden formfield
            // to empty string as well
            $seatsField.val('');

            // reset all checkboxes
            $('input[type="checkbox"]', $form)
                .prop('checked', false)
                .removeAttr('checked'); // @todo - this shouldn't be necessary

            $('.expand.active', $form).removeClass('active');

            if (options.submitForm) {
                submitForm();
            }

            $formResetButtons.hide();

            $('.ui.button.active', $form).removeClass('active');
        }

        $form.on('reset', resetForm);

        var simpleMenuButtonHandler = {
            // Marks a button as active, and its siblings
            // as not active
            activate: function () {
                $(this)
                    .addClass('active')
                    .siblings()
                    .removeClass('active');
            },
            activateThroughParents: function () {
                $(this)
                // activate the clicked button
                    .addClass('active')
                    // Get its parent element with class item
                    .parents('.item')
                    // Get all the other items in the menu
                    .siblings()
                    // Get all of their ui button children
                    .children('.ui.button')
                    // Deactivate them
                    .removeClass('active');
            },
            openFilterDrawer: function () {
                var drawer = this.dataset.target;
                var isOpened = true;
                var $activatedDrawer = $filterDrawer.children('#' + drawer);

                if (CH && CH.isMobile) {
                    $filterDrawer.slideDown('fast');
                } else {
                    $filterDrawer.show();
                }

                $activatedDrawer
                    .toggle()
                    .siblings()
                    .hide();

                if ($filterDrawer.children(':visible').length === 0) {
                    if (CH && CH.isMobile) {
                        $filterDrawer.slideUp('fast');
                    } else {
                        $filterDrawer.hide();
                    }
                    isOpened = false;
                }

                $filterSimpleContainer.toggleClass('filter-drawers-open', isOpened);

                // tell the page not to scroll
                if (CH && CH.isMobile) {
                    // @todo this isn't perfect in ios/safari
                    $body.toggleClass('noscroll', isOpened);
                }

                if (CH && !CH.isMobile) {
                    $stickyFilters && $stickyFilters.sticky('refresh');

                    if ($stickyMap.length && $stickyMap.is(':visible')) {
                        // re-set the map's sticky offset after drawer opens/closes
                        $stickyMap.sticky({
                            offset: $filterSimpleContainer.height() + 15,
                        });
                        $stickyMap.sticky('refresh');
                    }
                }

                // When in mobile mode we need to handle hiding & showing
                // the apply filters button
                if (CH && CH.isMobile) {
                    // Since the category filters are links to new pages
                    // we not need to display the apply filters button
                    // in face we want to make sure it's always hidden
                    if ($activatedDrawer[0].hasAttribute('data-filter-hide-apply')) {
                        $applyFilters.hide();
                    } else {
                        $applyFilters.toggle();
                    }
                }
            },
        };

        var $simpleMenuButtons = $('.menu .ui.button');
        var $filterDrawerToggles = $('.menu .ui.button.js-filter-toggle');
        var $commonTimeFilters = $('.js-common-day-buttons').children('.button');
        var $startTime = $('#start-time');
        var $endTime = $('#end-time');
        var $startDate = $('#start-date');
        var $endDate = $('#end-date');
        var $dropDowns = $('.filter-simple .ui.dropdown');
        var $seatFilters = $('#js-seats-filters');

        $dropDowns.dropdown();

        // this should be mobile-only behavior; when seat filter is a "select list"
        $seatFilters.find('.item', '.selection.list').on('click', function () {
            var $selectedItem = $(this);
            $seatsField.val($selectedItem.data('value'));
            $selectedItem.siblings('.active').removeClass('active');
            $selectedItem.addClass('active');
            toggleApplyFiltersButton();
        });

        // delegate; one of our reset buttons is loaded dynamically via ajax
        $filterPageContainer.on('click', '.js-form-reset', function () {
            $form.trigger('reset');
            $noResultsMessage.removeClass('active');
        });

        $commonTimeFilters.on('click', function () {
            var $this = $(this);
            var dayType = $this.data('value');
            var active = false;
            var $timeRange = $('#start-time, #end-time');

            $this
                .toggleClass('active')
                .siblings('.button')
                .removeClass('active');
            active = $this.hasClass('active');

            if (dayType === 'weeknights') {
                $('input[data-day-type=weekday]').prop('checked', active);
                $('input[data-day-type=weekend]').prop('checked', false);

                if (active) {
                    var sixPM = new Date();
                    sixPM.setHours(18);
                    sixPM.setMinutes(0);
                    sixPM.setSeconds(0);

                    var midnight = new Date();
                    // 12am
                    midnight.setHours(23);
                    midnight.setMinutes(59);
                    midnight.setSeconds(59);

                    $timeRange.calendar('set startDate', sixPM).calendar('set endDate', midnight);
                } else {
                    $timeRange.calendar('set startDate', null).calendar('set endDate', null);
                }
            }

            if (dayType === 'weekends') {
                $('input[data-day-type=weekend]').prop('checked', active);
                $('input[data-day-type=weekday]').prop('checked', false);
                $timeRange.calendar('set startDate', null).calendar('set endDate', null);
            }

            $('input', $daysAndTimesFilters).trigger('change');
        });

        function filterTimeRange(start, end) {
            if ((start || end) && start != end) {
                var startMinutes = start ? start.getHours() * 60 : '';
                var endMinutes = end ? end.getHours() * 60 : '';
                $timeField
                    .val(startMinutes + '-' + endMinutes)
                    .trigger('change');
            } else if (!start && !end && $timeField.val()) {
                $timeField.val('').trigger('change');
            }
        }

        $startTime.calendar({
            type: 'time',
            touchReadonly: true,
            disableMinute: true,
            endCalendar: $endTime,
            onChange: function (date, text, mode) {
                var end = $endTime.calendar('get date');
                filterTimeRange(date, end);

                // enable endTime if user has selected a startTime, otherwise disable
                $endTime
                    .find('input')
                    .prop('disabled', !date);
            },
        });

        $endTime.calendar({
            type: 'time',
            touchReadonly: true,
            disableMinute: true,
            startCalendar: $startTime,
            onChange: function (date, text, mode) {
                var start = $startTime.calendar('get date');
                var end = date;
                filterTimeRange(start, date);
            },
        });

        function setTimeFields(timeRangeValue, triggerChange) {
            triggerChange = typeof triggerChange !== 'undefined' ? triggerChange : true;

            // set start & end times
            if (timeRangeValue) {
                timeRangeValue = timeRangeValue.split('-');

                if (timeRangeValue.length === 2) {
                    var startTime = new Date();
                    startTime.setHours(timeRangeValue[0] / 60);
                    startTime.setMinutes(0);
                    startTime.setSeconds(0);
                    $startTime.calendar('set date', startTime, true, triggerChange);

                    var endTime = new Date();
                    endTime.setHours(timeRangeValue[1] / 60);
                    endTime.setMinutes(0);
                    endTime.setSeconds(0);
                    $endTime.calendar('set date', endTime, true, triggerChange);
                }
            } else {
                // make sure the calendar values are cleared
                $startTime.calendar('set date', null, true, triggerChange);
                $endTime.calendar('set date', null, true, triggerChange);

                // disable endTime when empty (require user enter in startTime first)
                $endTime
                    .find('input')
                    .trigger('blur')
                    .prop('disabled', !$startTime.calendar('get date'));
            }
        }

        var defaultTimeValue = $timeField.val();
        setTimeFields(defaultTimeValue, false);

        function filterDateRange(start, end) {
            if (start && end && start != end) {
                // trigger a filter when both start and end date fields are provided
                var formattedStart = formatDateForFilter(start);
                var formattedEnd = formatDateForFilter(end);
                $dateField.val(formattedStart + '-' + formattedEnd).trigger('change');
            } else if (!start && !end && $dateField.val()) {
                // trigger a filter when both start and end date fields are emptied
                $dateField.val('').trigger('change');
            }
        }

        var today = dayjs();

        /* Disable calendar cells in the semantic calendar plugin UI if the date is in the past
         * See https://github.com/mdehoog/Semantic-UI-Calendar#settings for more details
         * @param {} cell - The cell DOM node.
         * @param {Date} date - The date value the cell represents
         * @param {Object} cellOptions - Semantic UI Calendar options for displaying a date in a calendar cell
         */
        function disablePastDates(cell, date, cellOptions) {
            if (dayjs(date).isBefore(today, 'day')) {
                $(cell).addClass('disabled');
            }
        }

        $startDate.calendar({
            type: 'date',
            touchReadonly: true,
            endCalendar: $endDate,
            onChange: function (date, text, mode) {
                var end = $endDate.calendar('get date');

                // enable endDate if user has selected a startDate, otherwise disable
                $endDate
                    .find('input')
                    .prop('disabled', !date);

                filterDateRange(date, end);
            },
            // Calendar Cell UI formatting customization
            // See https://github.com/mdehoog/Semantic-UI-Calendar#settings for more details
            formatter: {
                cell: function (cell, date, cellOptions) {
                    disablePastDates(cell, date, cellOptions);
                },
            },
        });

        $endDate.calendar({
            type: 'date',
            touchReadonly: true,
            startCalendar: $startDate,
            onChange: function (date, text, mode) {
                var start = $startDate.calendar('get date');
                var end = date;
                filterDateRange(start, end);
            },
            // Calendar Cell UI formatting customization
            // See https://github.com/mdehoog/Semantic-UI-Calendar#settings for more details
            formatter: {
                cell: function (cell, date, cellOptions) {
                    disablePastDates(cell, date, cellOptions);
                },
            },
            popupOptions: {
                position: CH.isMobile ? 'top left' : 'bottom left',
                lastResort: CH.isMobile ? 'bottom left' : 'top left',
            },
        });

        function setDateFields(dateRangeValue, triggerChange) {
            triggerChange = typeof triggerChange !== 'undefined' ? triggerChange : true;

            if (dateRangeValue) {
                dateRangeValue = dateRangeValue.split('-');

                if (dateRangeValue.length === 2) {
                    var startDate = dayjs(dateRangeValue[0], 'MMDDYYYY').toDate();
                    $startDate.calendar('set date', startDate, true, triggerChange);

                    var endDate = dayjs(dateRangeValue[1], 'MMDDYYYY').toDate();
                    $endDate.calendar('set date', endDate, true, triggerChange);
                }
            } else {
                // make sure the calendar values are cleared
                $startDate.calendar('set date', null, true, triggerChange);
                $endDate.calendar('set date', null, true, triggerChange);

                // disable endTime when empty (require user enter in startTime first)
                $endDate
                    .find('input')
                    .trigger('blur')
                    .prop('disabled', !$startDate.calendar('get date'));
            }
        }

        // set default start & end times
        var defaultDateValue = $dateField.val();
        setDateFields(defaultDateValue, false);

        function formatDateForFilter(date) {
            // Javascript Months are 0 Indexed
            var month = (date.getMonth() + 1).toString();
            var day = date.getDate().toString();
            var year = date.getFullYear().toString();

            if (month.length === 1) {
                // Gotta left pad it
                month = '0' + month;
            }

            if (day.length === 1) {
                // Gotta left pad it
                day = '0' + day;
            }

            return month + day + year;
        }

        $simpleMenuButtons.on('click', simpleMenuButtonHandler.activateThroughParents);

        $filterDrawerToggles.on('click', simpleMenuButtonHandler.openFilterDrawer);

        var currencyFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
        });


        function setPriceSliderValues(priceRange, triggerChange) {
            triggerChange = typeof triggerChange !== 'undefined' ? triggerChange : true;

            if (priceRange) {
                priceRange = priceRange.split('-');

                priceSlider.noUiSlider.set(priceRange, triggerChange);
            }
        }

        $form.on('mouseenter', '.noUi-handle', function () {
            $(this).children('.noUi-tooltip').show();
        });

        $form.on('mouseleave', '.noUi-handle', function () {
            $(this).children('.noUi-tooltip').hide();
        });

        var noUiSliderCurrencyFormatter = {
            to: currencyFormatter.format,
            from: Math.floor,

        };
        var defaultPriceValue = $priceField.val();

        // "no results" page may not have any filter fields available
        if (priceSlider) {
            noUiSlider.create(priceSlider, {
                start: [0, 3000],
                connect: true,
                step: 5,
                tooltips: [
                    noUiSliderCurrencyFormatter,
                    noUiSliderCurrencyFormatter,
                ],
                range: {
                    min: minPriceVal,
                    max: maxPriceVal,
                },
                pips: {
                    mode: 'range',
                    density: 10,
                    format: noUiSliderCurrencyFormatter,
                },
            });

            setPriceSliderValues(defaultPriceValue, false);

            priceSlider.noUiSlider.on('update', function handlePriceRange(values) {
                var min; var
                    max;
                min = Math.floor(values[0]);
                max = Math.floor(values[1]);

                $priceMinText.text(currencyFormatter.format(min));
                $priceMaxText.text(currencyFormatter.format(max));

                var rangeVal = min + '-' + max;

                if (min == minPriceVal && max == maxPriceVal) {
                    rangeVal = '';
                }

                $priceField.val(rangeVal);
            });

            priceSlider.noUiSlider.on('set', function () {
                $priceField.trigger('change');
            });
        }

        // when someone clicks a borough expand button
        // then reveal all child hoods for that borough and hide the others
        // and toggle the +/- icon
        $neighborhoodFilters.on('click', '.expand', function (evt) {
            evt.preventDefault();
            var $expanderElement = $(this);
            var $selectedHoods = $hoods.filter('.' + $expanderElement.data('target'));
            var isExpanded = $expanderElement.children(':visible').hasClass('plus');

            // hide all... show/hide one
            $hoods.addClass('hidden');
            $neighborhoodFilters.find('.expand i.minus').hide();
            $neighborhoodFilters.find('.expand i.plus').show();

            $selectedHoods.toggleClass('hidden', !isExpanded);
            $('i.minus', $expanderElement).toggle(isExpanded);
            $('i.plus', $expanderElement).toggle(!isExpanded);

            // accomodate for height change of an absolute positioned thing
            // @todo - only if hoods are absolute / desktopy?
            $neighborhoodFilters.find('.field-container').css({
                minHeight: $selectedHoods.height() || '',
            });

            if ($stickyFilters && CH && !CH.isMobile) {
                $stickyFilters.sticky('refresh');
            }
        });

        // when someone clicks a borough
        // then auto-click all its children hoods
        $neighborhoodFilters.find('.js-borough-field').on('change', function () {
            var $boroughField = $(this).find('input[type=checkbox]');
            var targetHoodSelector = '.' + $boroughField.data('target');
            var $hoodFields = $hoods
                .filter(targetHoodSelector)
                .find('input[type=checkbox]');

            updateExpanderForHoods($boroughField);

            $hoodFields.prop('checked', $boroughField.prop('checked'));

            // make sure filter button shows active/inactive after this sweeping checkbox update
            if (CH && !CH.isMobile) {
                toggleActiveDrawerButtons($('#js-neighborhoods-filters'));
            }

            if (CH && CH.isMobile) {
                toggleApplyFiltersButton();
            }
        });

        $hoods.find('input[type=checkbox]').on('change', function () {
            updateExpanderForHoods($(this));
        });

        function updateExpanderForHoods($inputField) {
            var $fieldGroup = $inputField.parents('.js-borough-field');
            var target = $inputField.data('target');

            if ($fieldGroup.length) {
                // if is parent borough
                $fieldGroup
                    .siblings('.expand')
                    // activate if borough is checked or any child hoods are checked
                    .toggleClass('active',
                        $inputField.prop('checked')
                        || ($hoods.length && $hoods.filter('[data-parent="' + target + '"] input:checked').length));
            } else {
                // if its a child neighborhood
                $fieldGroup = $inputField.parents('.js-hood');

                $('.' + $fieldGroup.data('parent'))
                    .siblings('.expand')
                    .toggleClass('active', !!$fieldGroup.find('input:checked').length);
            }
        }

        // initialize parent hood checkboxes if child hoods are checked
        $hoods.find('input:checked').parents('.js-hood').each(function (index, el) {
            var parentHoodClass = $(el).data('parent');

            $('.' + parentHoodClass).siblings('.expand').addClass('active');
        });

        // when user goes back to a different filter request
        // then update the filter form and re-submit it
        $(window).on('popstate', function (e) {
            var formData = e.originalEvent.state;
            var $inputField;

            // clear form
            $form.trigger('reset', [{
                submitForm: false,
            }]);

            // clear hidden fields, which form reset does not touch
            $form
                .find('input[type=hidden]')
                .val('');

            if (formData && $.isArray(formData)) {
                // find the form control and update it
                $.each(formData, function (i, val) {
                    if (val.name.indexOf('[') >= 0) {
                        // checkbox groups (need escaping)
                        if (val.value.length > 0) {
                            $inputField = $('[name^="' + val.name.replace(/\[\]/g, '') + '"][value="' + val.value + '"]', $form);

                            $inputField
                                .prop('checked', true);

                            if ($inputField.prop('name') === 'neighborhood[]') {
                                updateExpanderForHoods($inputField);
                            }
                        }
                    } else {
                        // all text (visible and hidden) input controls
                        // do not "re set" values of radios and checkboxes here
                        $('input:text[name=' + val.name + '], input[name=' + val.name + '][type=hidden]', $form)
                            .val(val.value);

                        // radio buttons...
                        $('input[type=radio][name=' + val.name + '][value="' + val.value + '"]')
                            .prop('checked', true);

                        if (val.name === 'time') {
                            setTimeFields($timeField.val(), false);
                        } else if (val.name === 'date') {
                            setDateFields($dateField.val(), false);
                        } else if (val.name === 'price') {
                            setPriceSliderValues($priceField.val(), false);
                        }
                    }
                });
            }

            // trigger user-defined callback
            options.popStateCb();

            // re-submit the form with empty or updated filters
            // do not record history
            submitSimpleFilters(
                $form,
                $resultsColumn,
                false
            );
            toggleAllActiveDrawerButtons($filterDrawer, $form);
        });

        $moreFiltersDrawer.on('click', '.checkbox', function (e) {
            var $this = $(this);
            var $inputCb = $this.find('input[type=checkbox]');
            var $filters = $this.parents('.grouped.fields');

            if ($this.hasClass('any-checkbox')) {
                // uncheck all others
                $filters
                    .find('.checkbox')
                    .not($this)
                    .find('input[type=checkbox]')
                    .prop('checked', false);
            } else if ($inputCb.prop('checked')) {
                $filters
                    .find('.any-checkbox input[type=checkbox]')
                    .prop('checked', false);
            }
        });

        // Cache the value of the serialized form so we can react to changes properly on mobile
        formSerialized = serializeForm($form);

        toggleAllActiveDrawerButtons($filterDrawer, $form);

        initCategoryFilter();
        if (CH && CH.isMobile) {
            initMobileBehavior($form);
        }

        if (CH && CH.Hub && CH.Hub.uri === 'nyc') {
            $seatsField.on('change', event => {
                let attendees = parseInt(event.target.value);
                if (attendees >= 6) {
                    $grouperModal
                        .modal({
                            autofocus: false,
                            onShow: () => {
                                ga(
                                    'send',
                                    'event',
                                    'Grouper', // category
                                    'Viewed seats filter pop-up',
                                    `${attendees} attendees - ${window.location.pathname}`,
                                    { nonInteraction: false }
                                );
                            },
                            onApprove: () => {
                                ga(
                                    'send',
                                    'event',
                                    'Grouper', // category
                                    'Clicked seats filter pop-up',
                                    `${attendees} attendees - ${window.location.pathname}`,
                                    { nonInteraction: false }
                                );
                            },
                            onHide: () => {
                                // attempting to get the dropdown to hide after modal close
                                // alas, this wasn't perfect. not sure why semantic insists on focusing on the input
                                $seatsDropdown.dropdown('set active');
                                $seatsDropdown.dropdown('set visible');
                            },
                        })
                        .modal('show');

                }
            });

            $("[data-js='close-modal']", $grouperModal)
                .on('click', function (e) {
                    e.preventDefault();
                    $(this).modal('hide');
                });
        }

        // grab sticky elements so we can "refresh' them as we open/close filter drawers
        $stickyMap = CH && !CH.isMobile && $('.ui.sticky', '#filter-map-context');
        $stickyFilters = $('#filter-simple-container.ui.sticky');

        window.onWindowLoad(function () {
            initStickyFilters();
            if (CH && CH.isMobile) {
                setHeightOfMobileFilterDrawer();
            }
        });
    }

    /**
     * setHeightOfMobileFilterDrawer
     *
     * goal: determine vertical height the filter-drawer element can fill
     * determine an element that is visible, figure out the height of the screen
     * FROM the bottom of the filters TO the bottom of the viewport
     *
     */
    function setHeightOfMobileFilterDrawer(isFilterCurrentlySticky) {
        isFilterCurrentlySticky = typeof isFilterCurrentlySticky === 'undefined' ? false : isFilterCurrentlySticky;
        var newHeight;

        if (CH && CH.isMobile && $filterDrawer && $filterDrawer.length) {
            if (isFilterCurrentlySticky) {
                // when user has scrolled down enough to trigger "sticky" behavior
                // drawer height = [window] - [bottom VIEWPORT coordinate of the filter]
                newHeight = $(window).height() - $filterSimpleContainer[0].getBoundingClientRect().bottom;
            } else {
                // when the user is at or close to the top of the page, and sticky is disabled
                // drawer height = [window] - [top DOCUMENT coordinate of the filter] - [height of filter]
                newHeight = $(window).height() - $filterSimpleContainer.offset().top - $filterSimpleContainer.height();
            }

            $filterDrawer.css({
                height: newHeight,
            });
        }
    }

    function setMarginTopOfResultsContainer(isFilterCurrentlySticky) {
        isFilterCurrentlySticky = typeof isFilterCurrentlySticky === 'undefined' ? false : isFilterCurrentlySticky;
        var newMargin;

        if ($filterDrawer && $filterDrawer.length) {
            if (isFilterCurrentlySticky) {
                newMargin = $filterSimpleContainer.height();
            } else {
                newMargin = 0;
            }

            $browseContainer.css({
                'margin-top': newMargin,
            });
        }
    }

    /**
     * Initialize the Category filter area
     *
     * This is currently only supported by mobile
     *
     */
    function initCategoryFilter() {
        $categoryFilterDrawer = $('#js-subcategories-filters');

        if ($categoryFilterDrawer.length) {
            $categoryFilterDrawer.on('click', 'a.item', preserveQueryParams);
        }

        // We want to preserve all query params when the user clicks on a category link
        // in order to maintain filtering across their browsing
        // So we catch the event and jam them onto the href before changing the window's location
        $categoryNavigation = $('#category-navigation');

        if ($categoryNavigation.length) {
            $categoryNavigation.on('click', '.category-list-item a', preserveQueryParams);
        }
    }

    /*
     * preserveQueryParams
     *
     * Captures a navigation event, jams any existing query params (except "page")
     * onto the new url and then points the window's location to the url with the query params
     *
     * @param Event e
     * @param jQuerySelector $anchor
    */
    function preserveQueryParams(e) {
        let anchorUrl;
        let searchQueryParams;
        let mergedQueryParams;
        let queryEntries;
        const $anchor = $(this);

        e.preventDefault();

        // parse the urls/params
        anchorUrl = window.parseUri($anchor.attr('href'));
        searchQueryParams = window.parseUri(window.location.search);

        // merge all query params
        mergedQueryParams = Object.assign({}, anchorUrl.queryKey, searchQueryParams.queryKey);

        // exclude page param
        delete mergedQueryParams.page;

        // build up the link with the newly combined query params
        queryEntries = Object.entries(mergedQueryParams);

        window.location.href = (anchorUrl.protocol
            ? anchorUrl.protocol + '://' + anchorUrl.host
            : '')
            + anchorUrl.path
            + (queryEntries.length
                ? queryEntries.reduce((acc, curr) => {
                    return acc + (acc !== '?' ? '&' : '') + curr.join('=');
                }, '?')
                : '');
    }

    /**
     *
     * initStickyFilters
     *
     * Make the filter bar "sticky"
     *
     * Safe for mobile and desktop
     *
     * Warning: this should be run once styles are computed (window load)
     */
    function initStickyFilters() {
        var originalTopPadding = parseInt($filterPageContainer.css('paddingTop'));
        var includeMarginsInHeight = true;

        if (CH && CH.isMobile) {
            includeMarginsInHeight = false;
        }

        $stickyFilters.sticky({
            onStick: function () {
                setHeightOfMobileFilterDrawer(true);
                setMarginTopOfResultsContainer(true);
            },
            onUnstick: function () {
                setHeightOfMobileFilterDrawer(false);
                setMarginTopOfResultsContainer(false);
            },
            offset: 0, // px offset from the top of the page when sticky
            observeChanges: true, // adjust to page size changes
            context: '#filter-page-container', // "sticks" to this element as it scrolls
        });
    }

    function toggleAllActiveDrawerButtons($filterDrawer, $form) {
        $.each($filterDrawer.children(), function (i, elem) {
            toggleActiveDrawerButtons($(elem, $form));
        });
    }

    /**
     * For a given "drawer"
     * If any filter fields are set within it
     * Set the drawer button as "active"
     *
     * Special behavior/classes
     * "js-ignored-by-drawer" - prevents an input from affecting whether a filter button is "active"
     *
     * @param $drawer
     * @param $form
     */
    function toggleActiveDrawerButtons($drawer, $form) {
        var isFiltersActive = false;
        var drawerId = $drawer.attr('id');
        var $priceField;
        var range;

        if (drawerId === 'js-price-filters') {
            $priceField = $('input[name=price]', $form);

            if ($priceField.val()) {
                range = $priceField.val().split('-');
                isFiltersActive = +range[0] != minPriceVal || +range[1] != maxPriceVal;
            }
        } else {
            isFiltersActive = !!($(':checked', $drawer).not('.js-ignored-by-drawer').length
                || $('input[type=text][value!=""]', $drawer).not('.js-ignored-by-drawer').length
                || $('input[type=hidden][value!=""]', $drawer).not('.js-ignored-by-drawer').length);
        }

        // toggle this drawer's button active state
        $('.js-filter-toggle[data-target=' + drawerId + ']')
            .toggleClass('filter-active', isFiltersActive);

        // show reset button if any drawers fields (therefore, buttons) are active
        $formResetButtons
            .toggle($('.js-filter-toggle.filter-active').length > 0);
    }

    function initSortMenu() {
        var $sortMenu = $('.menu', '#js-sort-options');
        var $sortField = $('#sort', $form);

        $sortMenu.on('click', 'a', function (e) {
            var $sortLink = $(this);
            e.preventDefault();

            $sortLink.siblings('a').removeClass('active selected');
            $sortLink.addClass('active selected');

            $sortField
                .val($sortLink.data('value'))
                .trigger('change');
        });
    }

    function toggleActiveDrawerButtonsFromEvent(evt) {
        if (!evt) {
            $('.menu .ui.button.js-filter-toggle').removeClass('filter-active');
            return;
        }
        toggleActiveDrawerButtons($(evt.target).parents('.js-filters'));
    }

    function toggleApplyFiltersButton() {
        $('.js-apply-filters-button')
            .toggleClass('disabled', (formSerialized === serializeForm($form)));
    }

    return {
        init: initializeSimpleFilter,
    };
});

